import * as React from 'react';
const MinusIcon = ({ width = 16, height = 16, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    data-name='Flat Line'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 2,
      }}
      d='M19 12H5'
    />
  </svg>
);
export default MinusIcon;
